import { Component, Input, OnInit } from '@angular/core';
import { BufferDurations } from '../../user-dashboard/shared/buffer-durations.model';

@Component({
  selector: 'app-eta-approximation-form',
  templateUrl: './eta-approximation-form.component.html',
  styleUrls: ['./eta-approximation-form.component.scss']
})
export class EtaApproximationFormComponent implements OnInit {

  @Input()
  bufferDurations = new BufferDurations();

  @Input()
  writeMode = true;

  constructor() {
  }

  ngOnInit() {
  }

}
